import { hasLocationInUrl } from './locationDataFromUrl';

const getGeolocationInfo = (pathname, location) => {
  return hasLocationInUrl(pathname) ? location : null;
};

export default getGeolocationInfo;
